import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
const usePreferredStore = (storeName) => {
  const { getFormattedLabel, getLabel } = useIntl();
  const [preferredStoreState, setPreferredStoreState] = React.useState(null);
  const { preferredStoreSuccess, preferredStoreUpdated, preferredStoreLabel } = preferredStoreState ?? {};
  const preferredStoreAlertLabel = preferredStoreSuccess ? getFormattedLabel(preferredStoreLabel ?? "", {
    labelData: { storeName },
    parseLink: true
  }) : getLabel(preferredStoreLabel ?? "");
  const onHandlePreferredStoreChange = (updated, success, label) => {
    setPreferredStoreState({
      preferredStoreUpdated: updated,
      preferredStoreSuccess: success,
      preferredStoreLabel: label
    });
  };
  return {
    preferredStoreAlertLabel,
    preferredStoreUpdated,
    preferredStoreSuccess,
    onHandlePreferredStoreChange
  };
};
export {
  usePreferredStore as default
};
//# sourceMappingURL=use-preferred-store.js.map
